import { FormControlLabel, Switch } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import {
  autoFitMapAF,
  IRideDto,
  IRideRoute,
  MapRouteBlockTypeEnum,
} from "@ryde/shared";

import { MapToolboxDebugControls } from "./map-toolbox-debug-controls";
import { MapToolboxWrapperStyled } from "./map-toolbox.styled";
import { MapToolboxViewSelect } from "./map-toolbox.view-select";

interface IMapToolbox {
  routes: IRideRoute[];
  trackingCarRoutes?: IRideRoute[];
  rideDto?: IRideDto;
  routeBlockType: MapRouteBlockTypeEnum;
}

export const MapToolbox: FC<IMapToolbox> = ({
  routes,
  trackingCarRoutes,
  rideDto,
  routeBlockType,
}) => {
  const [autofitEnabled, setAutofitEnabled] = useRecoilState(
    autoFitMapAF(routeBlockType),
  );
  const { t } = useTranslation();

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setAutofitEnabled?.(event.target.checked || false);
  };

  return (
    <MapToolboxWrapperStyled>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={autofitEnabled || false}
            onChange={handleSwitchChange}
            name="autoFitEnabled"
          />
        }
        label={t("selectListLabel.AutofitEnabled")}
      />

      <MapToolboxDebugControls rideDto={rideDto} routes={routes} />

      <MapToolboxViewSelect
        trackingsCount={
          trackingCarRoutes?.[0]?.trackingRenderState?.pointCount ??
          trackingCarRoutes?.[0]?.locations?.length ??
          0
        }
        routeCount={routes?.[0]?.locations?.length || 0}
        routeBlockType={routeBlockType}
      />
    </MapToolboxWrapperStyled>
  );
};
